module.exports = __webpack_public_path__ + "img/icon_language.c47f3473.svg";